<script lang="ts" setup>
const { t } = useI18n()
const { toggleModal } = useOverlays()
const listsStore = useListsStore()
const localePath = useLocalePath()
const route = useRoute()
const userStore = useUserStore()

const navigation = computed(() => {
  const groups: LayoutHeaderNavigationGroups = [
    [
      {
        icon: getIcon('searchFeature'),
        label: t('navigation.search'),
        to: localePath('companies'),
      },
      {
        icon: getIcon('enrichmentFeature'),
        label: t('navigation.enrichment'),
        to: localePath('companies-enrichment'),
      },
      {
        icon: getIcon('similarityFeature'),
        label: t('navigation.similarity'),
        to: localePath({
          name: 'companies-similarity',
          query: { domains: 'microsoft.com' },
        }),
      },
    ],
  ]

  // Add lists if some are available
  if (userStore.user) {
    if (listsStore.lists.length) {
      groups.push([
        {
          chip: listsStore.unseenActionsCount,
          icon: getIcon('list'),
          id: 'companies-lists-listId',
          label: t('globals.list', 2),
          to: localePath({
            name: 'companies-lists-listId',
            params: {
              listId: listsStore?.firstListWithUnseenActions?.id
                ? listsStore.firstListWithUnseenActions.id
                : listsStore.lists?.[0]?.id,
            },
          }),

          active: String(route.name).startsWith('companies-lists-listId'),

          onClick: async () => {
            if (
              String(route.name).startsWith('companies-lists-listId')
              && listsStore?.firstListWithUnseenActions?.id
              && Number(route.params.listId) === listsStore.firstListWithUnseenActions.id
            ) {
              await listsStore.updateList({
                lastSeen: true,
                listId: listsStore.firstListWithUnseenActions.id,
              })
            }
          },
        },
      ])
    }
    else {
      groups.push([
        {
          icon: getIcon('list'),
          label: t('navigation.createFirstList'),
          onClick: () => {
            toggleModal({
              opened: true,
              type: 'list',
            })
          },
          to: localePath('companies-lists'),
        },
      ])
    }
  }

  return groups
})

definePageMeta({ hasSubnav: true })
</script>

<template>
  <LayoutHeaderNavigation
    key="companies"
    :navigation="navigation"
  />

  <UContainer class="py-20">
    <NuxtPage :key="route.name" />
  </UContainer>
</template>

<i18n lang="json">
{
  "en": {
    "navigation": {
      "createFirstList": "Create your first list",
      "enrichment": "Enrichment",
      "search": "Search",
      "similarity": "Similarity"
    }
  },
  "es": {
    "navigation": {
      "createFirstList": "Crea tu primera lista",
      "enrichment": "Enriquecimiento",
      "search": "Búsqueda",
      "similarity": "Similaridad"
    }
  },
  "fr": {
    "navigation": {
      "createFirstList": "Créer votre première liste",
      "enrichment": "Enrichissement",
      "search": "Recherche",
      "similarity": "Similarité"
    }
  }
}
</i18n>
